/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.index-of.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Swiper from "vux/src/components/swiper/swiper.vue";
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import wx from 'jweixin-1.2.0';
import XImg from '@/components/XImg';
import MoreDiv from '@/components/MoreDiv';
import Month from '@/components/Month';
import doctor_head from '@/resources/images/doctorDefault.png';
export default {
  props: {
    doctorInfo: {
      type: Object
    },
    flag: {
      type: String
    },
    minDate: String,
    maxDate: String,
    dateWithDot: Array,
    childClinicId: String
  },
  data: function data() {
    return {
      imgWidth: '1.52rem',
      imgHeight: '2rem',
      userDefault: '',
      doctorId: '',
      apptDates: {},
      doctor_head: doctor_head,
      apptPayFlag: ''
    };
  },
  components: {
    Month: Month,
    XImg: XImg,
    MoreDiv: MoreDiv
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters({})), {}, {
    isChain: function isChain() {
      if (this.flag == 'chain') {
        return true;
      } else {
        return false;
      }
    },
    clinicPhotoPath: function clinicPhotoPath() {
      var imgSrc = this.doctorInfo.doctorHeadPicture;
      var clinicPhotoPath = '';

      if (imgSrc && imgSrc != 'null') {
        if (imgSrc.indexOf("http") === -1 && imgSrc.indexOf('data:image') === -1) {
          if (imgSrc.indexOf('clinic/doctor') > -1) {
            clinicPhotoPath = Cons.SH_IMGROOT_PATH + imgSrc;
          } else {
            clinicPhotoPath = Cons.SZ_IMGROOT_PATH + imgSrc;
          }
        } else {
          clinicPhotoPath = imgSrc;
        }
      } else {
        clinicPhotoPath = doctor_head;
      }

      return clinicPhotoPath;
    }
  }),
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions({})), {}, {
    dateSelected: function dateSelected(d) {
      this.$emit('dateSelected', d);
    },
    nextWeek: function nextWeek(startDate, endDate) {
      this.$emit('nextWeek', startDate, endDate);
    },
    lastWeek: function lastWeek(startDate, endDate) {
      this.$emit('lastWeek', startDate, endDate);
    },
    goClinicDetail: function goClinicDetail(childClinicId, childClinicName) {
      this.$emit('goClinicDetail', childClinicId, childClinicName);
    }
  })
};